<!-- Fora do `LayoutComponent`: a classe de versão vem da diretiva. -->
<main class="public-screen" appAccountVersionTheme>
  <div class="public-card">
    <div class="brand-bar"></div>
    <div class="public-card-body">
      <div class="logo">
        <img src="/assets/logo-smsfunnel-login.png" alt="SMS Funnel" title="SMS Funnel" />
      </div>

      <div class="invite-state" *ngIf="view === 'loading'" data-testid="invite-loading">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="screen-hint">Conferindo o convite...</p>
      </div>

      <!-- `action` fixo: sem ele o navegador usa a URL da página, e o GA4 manda o
           token da rota no `form_destination` do evento `form_start`. -->
      <form class="public-form" action="/" *ngIf="view === 'valid'" [formGroup]="form" (submit)="accept()"
        data-testid="invite-form">
        <p class="screen-label">Você foi convidado para a equipe</p>
        <p class="screen-hint">
          Você recebeu acesso à conta
          <strong *ngIf="invitation.account_name">{{ invitation.account_name }}</strong>
          no SMS Funnel. Crie sua senha para entrar.
        </p>

        <div class="invitee mt-4" data-testid="invite-invitee">
          <span class="invitee-name">{{ invitation.name }}</span>
          <span class="invitee-email">{{ invitation.email }}</span>
        </div>

        <div class="form-group">
          <label for="invite-password">Crie sua senha</label>
          <input id="invite-password" type="password" class="form-control" formControlName="password"
            autocomplete="new-password" data-testid="invite-password" />
        </div>

        <div class="form-group">
          <label for="invite-password-confirmation">Confirme a senha</label>
          <input id="invite-password-confirmation" type="password" class="form-control"
            formControlName="password_confirmation" autocomplete="new-password" placeholder="Repita a senha"
            data-testid="invite-password-confirmation" />
        </div>

        <ul class="password-rules" data-testid="invite-password-rules">
          <li [class.ok]="hasMinLength">
            <i class="fa" [ngClass]="hasMinLength ? 'fa-check' : 'fa-circle-o'"></i>
            Mínimo de {{ minLength }} caracteres
          </li>
          <li [class.ok]="passwordsMatch">
            <i class="fa" [ngClass]="passwordsMatch ? 'fa-check' : 'fa-circle-o'"></i>
            Senhas iguais
          </li>
        </ul>

        <div class="form-group d-grid">
          <button class="btn btn-primary" [appLoadingButton]="isSubmitting" [disabled]="form.invalid"
            data-testid="invite-submit">
            Criar acesso
          </button>
        </div>

        <span class="field-hint text-center">O e-mail do convite não pode ser alterado.</span>
      </form>

      <div class="invite-state" *ngIf="view === 'expired' || view === 'invalid'" data-testid="invite-unavailable">
        <i class="fa fa-clock-o fa-2x"></i>
        <p class="state-title">Este convite não é mais válido</p>
        <p class="screen-hint" *ngIf="view === 'expired'">
          O link expirou (validade de 48 h) ou foi cancelado. Peça ao proprietário da conta para reenviar o convite.
        </p>
        <p class="screen-hint" *ngIf="view === 'invalid'">
          O link está incompleto ou foi cancelado. Peça ao proprietário da conta para enviar um novo convite.
        </p>
        <div class="public-links">
          <a routerLink="/login" data-testid="invite-go-login">Ir para o login <i class="fa fa-chevron-right"></i></a>
        </div>
      </div>

      <div class="invite-state" *ngIf="view === 'error'" data-testid="invite-error">
        <i class="fa fa-exclamation-circle fa-2x"></i>
        <p class="state-title">Não foi possível conferir o convite</p>
        <p class="screen-hint">Verifique sua conexão e tente de novo em instantes.</p>
        <div class="form-group d-grid mt-4">
          <button type="button" class="btn btn-primary" (click)="retry()" data-testid="invite-retry">
            Tentar de novo
          </button>
        </div>
      </div>

      <div class="invite-state" *ngIf="view === 'accepted' || view === 'done'" data-testid="invite-accepted">
        <i class="fa fa-check fa-2x ok"></i>
        <p class="state-title">{{ view === 'done' ? 'Acesso criado' : 'Este convite já foi aceito' }}</p>
        <p class="screen-hint">Entre com seu e-mail e a senha que você definiu.</p>
        <p class="screen-hint" *ngIf="loggedAs as email" data-testid="invite-logged-as">
          Este navegador está conectado como <strong>{{ email }}</strong>. Essa sessão será encerrada ao entrar.
        </p>
        <div class="form-group d-grid mt-4">
          <button type="button" class="btn btn-primary" (click)="goToLogin()" data-testid="invite-enter">
            Entrar no painel
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
